import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { ModalProvider } from './components/ModalSystem';
import { CopilotProvider } from './components/Copilot/CopilotProvider';
import CopilotPanel from './components/Copilot/CopilotPanel';
import CoachOverlay from './components/Copilot/CoachOverlay';
import { WalkthroughProvider } from './components/Walkthrough/WalkthroughProvider';
import WalkthroughOverlay from './components/Walkthrough/WalkthroughOverlay';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ModalProvider>
        <WalkthroughProvider>
          <CopilotProvider>
            <App />
            <CopilotPanel />
            <CoachOverlay />
            <WalkthroughOverlay />
          </CopilotProvider>
        </WalkthroughProvider>
      </ModalProvider>
    </ErrorBoundary>
  </React.StrictMode>
);